const button = $('form.wpcf7-form').find('input[type=submit]');

window.addEventListener('load', (event) => {
  button.prop("disabled", true);
});

$("form.wpcf7-form input:checkbox").on("change", function () {
  const checked = [];
  $("form.wpcf7-form input:checkbox").each(function () {
    if ($(this).is(":checked")) {
      checked.push($(this).val());
    }
  });
  (checked.length === 0) ? button.prop("disabled", true) : button.prop("disabled", false);
});
